'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getCsrfToken = getCsrfToken;
exports.addCsrfToken = addCsrfToken;
exports.htmlAjax = htmlAjax;
exports.default = ajax;
exports.submitForm = submitForm;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _initialize = require('../core/initialize');

var _appPath = require('../core/appPath');

var _appPath2 = _interopRequireDefault(_appPath);

var _localize = require('../core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _cookie = require('./cookie');

var _message = require('../message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');
var log = require('debug')('linksoft:ajax');

var tokenCookieName = 'XSRF-TOKEN';
var tokenHeaderName = 'X-XSRF-TOKEN';

_jquery2.default.ajaxSetup({
	cache: false
});

function getCsrfToken() {
	return (0, _cookie.getCookie)(tokenCookieName);
}

function addCsrfToken(request) {
	request.setRequestHeader(tokenHeaderName, getCsrfToken());
}

// set CSRF token header
(0, _jquery2.default)(document).ajaxSend(function (event, request, settings) {
	if (!settings.headers || settings.headers[tokenHeaderName] === undefined) {
		addCsrfToken(request);
	}
});

function abpAjax(userOptions) {

	var options = _extends({}, userOptions);
	options.success = undefined;
	options.error = undefined;

	ajaxBegin(userOptions.target, options);

	return _jquery2.default.Deferred(function ($dfd) {
		_jquery2.default.ajax(options).done(function (data, textStatus, jqXHR) {
			if (data && data.__abp) {
				handleResponse(data, userOptions, $dfd, jqXHR);
			} else {
				$dfd.resolve(data);
				userOptions.success && userOptions.success(data, status, jqXHR);
			}

			if (userOptions.method == 'GET') {
				(0, _initialize.initialize)();
			}
			log('ajax request done');
		}).fail(function (jqXHR) {
			if (jqXHR.responseJSON && jqXHR.responseJSON.__abp) {
				handleResponse(jqXHR.responseJSON, userOptions, $dfd, jqXHR);
			} else {
				handleNonAbpErrorResponse(jqXHR, userOptions, $dfd);
			}
			//call('ajaxFailure', userOptions.target);
		}).always(function () {
			ajaxComplete(userOptions.target);
		});
	});
}

// function call(ajaxCallbackName, context) {
// 	log('calling ' + ajaxCallbackName);
// 	const func = _get(config(), 'ajax.' + ajaxCallbackName);
// 	if (isFunction(func)) {
// 		func.apply(context || document);
// 		log('called ' + ajaxCallbackName);
// 	}
// }


function ajaxBegin(element) {
	if (!element) return;
	var $this = (0, _jquery2.default)(element);
	$this.data('ajaxInProgress', true);
	var target = $this.attr("data-ajax-update") || $this;
	if (target && element !== document) {
		abp.ui.block(target);
	}
}
//
// function ajaxFailure(error) {
// 	message.error(error || Resx.Common.AjaxError);
// }

function ajaxComplete(element) {
	if (element) {
		var $this = (0, _jquery2.default)(element);
		$this.data('ajaxInProgress', false);
		var target = $this.attr("data-ajax-update") || $this;
		if (target && element !== document) {
			abp.ui.unblock(target);
		}
	} else {
		abp.ui.unblock();
	}
}

function handleNonAbpErrorResponse(jqXHR, userOptions, $dfd) {
	if (userOptions.abpHandleError !== false) {
		switch (jqXHR.status) {
			case 401:
				handleUnAuthorizedRequest(_message2.default.warn(Resx.Common.HttpError401), (0, _appPath2.default)());
				break;
			case 403:
				_message2.default.error(Resx.Common.HttpError403);
				break;
			case 404:
				_message2.default.error(Resx.Common.HttpError404);
				break;
			default:
				_message2.default.error(Resx.Common.SystemError);
				break;
		}
	}

	$dfd.reject.apply(this, arguments);
	userOptions.error && userOptions.error.apply(this, arguments);
}

function handleUnAuthorizedRequest(messagePromise, targetUrl) {
	if (messagePromise) {
		messagePromise.done(function () {
			handleTargetUrl(targetUrl);
		});
	} else {
		handleTargetUrl(targetUrl);
	}
}

function handleTargetUrl(targetUrl) {
	location.href = (0, _appPath2.default)(targetUrl);
}

function handleResponse(data, userOptions, $dfd, jqXHR) {
	if (data) {
		if (data.success === true) {
			$dfd && $dfd.resolve(data.result, data, jqXHR);
			userOptions.success && userOptions.success(data.result, data, jqXHR);

			if (data.targetUrl) {
				location.href = data.targetUrl;
			}
		} else if (data.success === false) {
			var messagePromise = null;

			if (data.error) {
				if (userOptions.abpHandleError !== false && data.error.message) {
					messagePromise = _message2.default.error(data.error.message);
				}
			} else {
				data.error = Resx.Common.SystemError;
			}

			log(data.error);

			$dfd && $dfd.reject(data.error, jqXHR);
			userOptions.error && userOptions.error(data.error, jqXHR);

			if (jqXHR.status === 401 && userOptions.abpHandleError !== false) {
				handleUnAuthorizedRequest(messagePromise, data.targetUrl);
			}
		} else {
			//not wrapped result
			$dfd && $dfd.resolve(data, null, jqXHR);
			userOptions.success && userOptions.success(data, null, jqXHR);
		}
	} else {
		//no data sent to back
		$dfd && $dfd.resolve(jqXHR);
		userOptions.success && userOptions.success(jqXHR);
	}
}

function getFunction(code, argNames) {
	if (typeof code === 'function') return code;
	var fn = window,
	    parts = (code || "").split(".");
	while (fn && parts.length) {
		fn = fn[parts.shift()];
	}
	if (typeof fn === "function") {
		return fn;
	}
	argNames.push(code);
	return Function.constructor.apply(null, argNames);
}
//
// function isMethodProxySafe(method) {
// 	return method === "GET" || method === "POST";
// }

function asyncOnSuccess(element, data, contentType) {
	var mode = void 0;

	if (contentType.indexOf("application/x-javascript") !== -1) {
		// jQuery already executes JavaScript for us
		return;
	}
	if (contentType.indexOf("application/json") !== -1) {
		// we do not handle JSON response here
		return;
	}

	mode = ((0, _jquery2.default)(element).attr("data-ajax-mode") || "").toUpperCase();
	(0, _jquery2.default)((0, _jquery2.default)(element).attr("data-ajax-update")).each(function (i, update) {
		var top = void 0;

		switch (mode) {
			case "BEFORE":
				top = update.firstChild;
				(0, _jquery2.default)("<div />").html(data).contents().each(function () {
					update.insertBefore(this, top);
					(0, _initialize.initialize)(this);
				});
				break;
			case "AFTER":
				(0, _jquery2.default)("<div />").html(data).contents().each(function () {
					update.appendChild(this);
					(0, _initialize.initialize)(this);
				});
				break;
			case "REPLACE-WITH":
				{
					var $data = (0, _jquery2.default)(data);
					(0, _initialize.finalize)(update);
					(0, _jquery2.default)(update).replaceWith($data);
					(0, _initialize.initialize)($data);
					break;
				}
			case "REPLACE":
			default:
				{
					var _$data = (0, _jquery2.default)(data);
					(0, _initialize.finalize)(update);
					(0, _jquery2.default)(update).html(_$data);
					(0, _initialize.initialize)(update);
					break;
				}
		}
	});
}

function htmlAjax(options) {
	var method = void 0;
	var element = options.target;

	_jquery2.default.extend(options, {
		//dataType: 'html',
		contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
		method: (0, _jquery2.default)(element).attr("data-ajax-method") || undefined,
		url: (0, _jquery2.default)(element).attr("data-ajax-url") || undefined,
		cache: ((0, _jquery2.default)(element).attr("data-ajax-cache") || "").toLowerCase() === "true",
		beforeSend: function beforeSend(xhr) {
			// if (!isMethodProxySafe(method)) {
			//     xhr.setRequestHeader("X-HTTP-Method-Override", method);
			// }
			return getFunction((0, _jquery2.default)(element).attr("data-ajax-begin"), ["xhr"]).apply(element, arguments);
		},
		complete: function complete() {
			getFunction((0, _jquery2.default)(element).attr("data-ajax-complete"), ["xhr", "status"]).apply(element, arguments);
		},
		success: function success(data, status, xhr) {
			asyncOnSuccess(element, data, xhr.getResponseHeader("Content-Type") || "text/html");
			getFunction((0, _jquery2.default)(element).attr("data-ajax-success"), ["data", "status", "xhr"]).apply(element, arguments);
		},
		error: function error() {
			getFunction((0, _jquery2.default)(element).attr("data-ajax-failure"), ["xhr", "status", "error"]).apply(element, arguments);
		}
	});

	//TODO: is this necessary???
	// options.data.push({name: "X-Requested-With", value: "XMLHttpRequest"});
	//
	// method = options.method.toUpperCase();
	// if (!isMethodProxySafe(method)) {
	//     options.method = "POST";
	//     options.data.push({name: "X-HTTP-Method-Override", value: method});
	// }

	return abpAjax(options);
}

//
// _set(config(), 'ajax', {
// 	ajaxComplete: ajaxComplete,
// 	ajaxBegin: ajaxBegin,
// 	ajaxFailure: ajaxFailure,
// 	ajaxSuccess: ajaxSuccess
// });


function ajax(userOptions) {
	userOptions = userOptions || {};
	// if userOptions contains target element, use unobstrusive ajax implementation
	if (userOptions.target) {
		return htmlAjax(userOptions);
	}
	return abpAjax(userOptions);
};

/**
 * Programmatically submits HTML form using AJAX call.
 * @param form
 * @param button An element that caused submit event.
 * @returns {Promise.<string|object>}
 */
function submitForm(form, button) {
	form = (0, _jquery2.default)(form).get(0); // to ensure we have dom element
	var clickTarget = (0, _jquery2.default)(button);

	var $icon = (0, _jquery2.default)(clickTarget).find('i.fa');
	$icon.data('orig-class', $icon.attr('class'));
	$icon.attr('class', 'fa fa-refresh fa-spin');

	// serializeArray() strips out info about buttons included in the form
	var formData = (0, _jquery2.default)(form).serializeArray();
	if (clickTarget.hasClass('include-in-form')) {
		// re-add information about button -
		// this enables to distinguish which button was clicked in case we have multiple submit buttons
		formData.push({ name: clickTarget.attr('name'), value: clickTarget.attr('value') });
	}

	return ajax({
		target: form,
		url: form.action,
		method: form.method || "GET",
		data: formData
	}).then(function (data) {
		$icon.attr('class', $icon.data('orig-class'));
		return data;
	}).fail(function () {
		$icon.attr('class', $icon.data('orig-class'));
	});
}

//
//
// export function asyncRequest(element, option		s) {
// 	options = options || {};
// 	options.target = element;
// 	return ajax(options);
// }


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/ajax.js
// module id = 63
// module chunks = 0